// Chinese Simplified translations.
export const zh = {
  // Navigation
  'nav.overview': '概览',
  'nav.dashboard': '仪表板',
  'nav.analytics': '分析',
  'nav.reportingDashboard': '报告仪表板',
  'nav.sales': '销售',
  'nav.salesOrders': '销售订单',
  'nav.purchase': '采购',
  'nav.purchaseOrders': '采购订单',
  'nav.purchaseReview': '审核工作区',
  'nav.purchase.sprints': '冲刺',
  'nav.supplierOnboarding': '供应商入驻',
  'nav.po': 'PO',
  'nav.po.sprints': '冲刺',
  'nav.po.newSprint': '创建冲刺',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': '周计划',
  'nav.scout.tagesplanung': '日计划',
  'nav.scout.prequal': 'PreQual 呼叫',
  'nav.scout.missionen': '任务',
  'nav.scout.missionControl': '任务控制中心',
  'nav.scout.unternehmenssuche': '企业搜索',
  'nav.scout.preferences': '偏好设置',
  'nav.scout.hilfe': '帮助',
  'nav.scout.scorecard': '记分卡',
  'nav.poSprints': 'PO/冲刺',
  'nav.wiki': '知识库',
  'nav.supportVisualization': '支持可视化',
  'nav.navigationTiles': '导航图块',
  'nav.styleGuide': '样式指南',
  'nav.inventory': '库存',
  'nav.items': '商品',
  'nav.warehouse': '仓库',
  'nav.picking': '拣货',
  'nav.asn': 'ASN',
  'nav.returns': '退货',
  'nav.accounting': '会计',
  'nav.accountsReceivable': '应收账款',
  'nav.crm': '客户管理',
  'nav.leads': '线索',
  'nav.contacts': '联系人',
  'nav.ai': 'AI',
  'nav.commandCenter': '指挥中心',
  'nav.workflows': '工作流',
  'nav.workflowManagement': '工作流管理',
  'nav.projectManagement': '项目管理',
  'nav.support': '支持',
  'nav.tickets': '工单',
  'nav.pivotTable': '数据透视表',
  'nav.learning': '学习',
  'nav.curriculumPlanning': '课程规划',
  'nav.learnerDashboard': '学习者仪表板',
  'nav.accessibleLearnerDashboard': '无障碍学习者仪表板',
  'nav.settings': '设置',
  'nav.general': '通用',
  'nav.company': '公司',
  'nav.addressManagement': '地址管理',
  'nav.usersRoles': '用户与角色',
  'nav.auditLog': '审计日志',
  'nav.integrations': '集成',
  'nav.appOverview': '应用概览',
  'nav.appOverviewDescription': '点击任意应用进行导航，或拖动图块重新排序',
  'header.help': '帮助',
  'header.account': '账户',
  'header.portalName': 'CLANDA 门户',
  'header.preferences': '偏好设置',
  'header.language': '语言',

  // Help page

  // Privacy page

  // Form

  // Placeholders
  
  // Status
  
  // Actions
  'action.delete': '删除',
  
  // Messages
  'message.success': '成功',
  'message.error': '错误',
  
  // Common
  'common.yes': '是',
  'common.no': '否',
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.save': '保存',
  'common.saveChanges': '保存更改',
  'common.close': '关闭',
  'common.reset': '重置',
  'common.back': '返回',
  'common.loading': '加载中...',
  'common.search': '搜索',
  'common.search.placeholder': '搜索...',
  'common.filter': '筛选',
  'common.sort': '排序',
  'common.add': '添加',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.error': '错误',
  'common.remove': '移除',
  'common.minutesShort': '{{value}} 分钟',
  'common.na': '不适用',
  'common.days': '天',
  'common.status.active': '活跃',
  'common.status.paused': '已暂停',
  'common.status.stopped': '已停止',
  'common.status.pending': '待处理',
  'common.status.completed': '已完成',
  'common.status.planned': '已计划',
  'common.status.inProgress': '进行中',
  'common.status.done': '已完成',
  'common.apply': '应用',
  'common.actions.filter': '筛选',
  'common.actions.export': '导出',
  'common.actions.search': '搜索',
  'common.dialog.defaultTitle': '对话框',
  'common.all': '全部',
  'common.total': '总计',
  'common.pending': '待处理',
  'common.assigned': '已分配',
  'common.inProgress': '进行中',
  'common.completed': '已完成',
  'common.cancelled': '已取消',
  'common.approved': '已批准',
  'common.rejected': '已拒绝',
  'common.processing': '处理中',
  'common.overdue': '已逾期',
  'common.partial': '部分',
  'common.highPriority': '高优先级',
  'common.tableView': '表格视图',
  'common.cardView': '卡片视图',
  'common.switchToTable': '切换到表格视图',
  'common.switchToCard': '切换到卡片视图',
  'common.openMenu': '打开菜单',
  'common.details': '详情',
  'common.overview': '概览',
  'common.new': '新建',
  'common.draft': '草稿',
  'common.shipped': '已发货',
  'common.delivered': '已送达',
  'common.received': '已接收',
  'common.inTransit': '运输中',
  'common.itemsPicked': '已拣货商品',
  'common.totalRefund': '退款总额',
  'common.totalPrice': '总价',
  'common.orderSummary': '订单摘要',
  'common.subtotal': '小计：',
  'common.tax': '税费：',
  'common.discount': '折扣：',
  'common.totalColon': '总计：',

  // Date Range Filter (canonical component)
  'dateRange.today': '今天',
  'dateRange.yesterday': '昨天',
  'dateRange.last7Days': '最近7天',
  'dateRange.last14Days': '最近14天',
  'dateRange.last30Days': '最近30天',
  'dateRange.thisMonth': '本月',
  'dateRange.custom': '自定义',

  // Dashboard
  'widget.vsLastPeriod': '与上期相比',
  'table.showing': '显示',
  'table.of': '共',
  'table.page': '页',
  'table.previous': '上一页',
  'table.next': '下一页',
  'table.filterGroups': '筛选组',
  'table.addFilterGroup': '添加筛选组',
  'table.filterGroup': '筛选组',
  'table.addCondition': '添加条件',
  'table.operator': '运算符',
  'table.field': '字段',
  'table.noFilterGroups': '暂无筛选组。',
  'filter.operator.equals': '等于',
  'filter.operator.not_equals': '不等于',
  'filter.operator.contains': '包含',
  'filter.operator.not_contains': '不包含',
  'filter.operator.starts_with': '开头为',
  'filter.operator.ends_with': '结尾为',
  'filter.operator.gt': '大于',
  'filter.operator.lt': '小于',
  'filter.operator.gte': '大于等于',
  'filter.operator.lte': '小于等于',
  'filter.operator.between': '介于',
  'filter.operator.in': '属于',
  'filter.operator.not_in': '不属于',
  'filter.operator.is_set': '已设置',
  'filter.operator.is_not_set': '未设置',
  'filter.placeholder.value': '值',
  'filter.placeholder.min': '最小',
  'filter.placeholder.max': '最大',
  'filter.placeholder.select': '选择…',
  'filter.placeholder.selectMultiple': '选择多个值…',
  'filter.logic.and': '且',
  'filter.logic.or': '或',

  // Documents
  
  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': '账户设置',

  // Consent
  'consent.title': '同意',
  'consent.label': '我同意条款和订购政策',
  'consent.description': '我已阅读并接受条款。',
  'consent.required': '请同意条款。',
  'consent.link.terms': '条款',

  // Contacts
  'contacts.title': '联系人',
  'contacts.role': '角色',
  'contacts.role.admin': '管理员',
  'contacts.role.billing': '财务',
  'contacts.role.technical': '技术',
  'contacts.role.other': '其他',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': '身份验证',

  // Debug

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page


  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Learning & Development
  'learning.feed.greeting': '你好 {{name}}！',
  'learning.feed.levelInfo': '等级 {{level}} • {{xp}} XP',
  'learning.feed.offline': '离线',
  'learning.feed.streakLabel': '连续天数',
  'learning.feed.dailyGoal': '每日目标',
  'learning.feed.recommendedLessons': '推荐课程',
  'learning.feed.priority.high': '高',
  'learning.feed.priority.medium': '中',
  'learning.feed.priority.low': '低',
  'learning.feed.difficulty.easy': '简单',
  'learning.feed.difficulty.medium': '中等',
  'learning.feed.difficulty.hard': '困难',
  'learning.feed.aiRecommendation': 'AI推荐',
  'learning.feed.actions.start': '开始',
  'learning.feed.actions.skip': '跳过',
  'learning.feed.actions.reload': '重新加载',
  'learning.feed.empty.title': '所有课程已完成！',

  // Helpdesk / Tickets
  'learning.feed.empty.description': '你已完成今天所有可用课程。明天再来！',
  'learning.quiz.title': '测验',
  'learning.quiz.questionCounter': '第 {{current}} 题，共 {{total}} 题',
  'learning.quiz.options.true': '正确',
  'learning.quiz.options.false': '错误',
  'learning.quiz.actions.next': '下一题',
  'learning.quiz.actions.finish': '完成',
  'learning.quiz.actions.retry': '重试',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}秒',
  'learning.quiz.result.passedTitle': '测验通过！',
  'learning.quiz.result.failedTitle': '测验未通过',
  'learning.quiz.result.scoreSummary': '{{correct}} / {{total}} 正确',
  'learning.quiz.result.xpEarned': '+{{xp}} XP 获得',
  'learning.quiz.result.answersHeading': '详细答案',
  'learning.quiz.result.questionLabel': '第 {{index}} 题',
  'learning.quiz.result.yourAnswer': '你的答案',
  'learning.quiz.result.correctAnswer': '正确答案',
  'learning.lessonCard.difficulty.easy': '简单',
  'learning.lessonCard.difficulty.medium': '中等',
  'learning.lessonCard.difficulty.hard': '困难',
  'learning.lessonCard.status.completed': '已完成',
  'learning.lessonCard.reward': '奖励',
  'learning.lessonCard.progress': '进度',
  'learning.lessonCard.selectFormat': '选择格式',
  'learning.lessonCard.prerequisites': '先决条件',
  'learning.lessonCard.actions.start': '开始',
  'learning.lessonCard.actions.repeat': '重复',
  'learning.lessonCard.actions.pause': '暂停',
  'learning.lessonCard.actions.complete': '完成',
  'learning.lessonCard.actions.bookmark': '收藏',
  'learning.lessonCard.actions.unbookmark': '取消收藏',
  'learning.lessonCard.actions.collapse': '收起',
  'learning.lessonCard.actions.expand': '展开',
  'learning.lessonCard.goalLabel': '目标',
  'learning.lessonCard.formats.video': '观看视频',
  'learning.lessonCard.formats.text': '阅读文本',
  'learning.lessonCard.formats.audio': '收听音频',
  'learning.lessonCard.formats.cheatSheet': '速查表',
  'learning.lessonCard.formatUnknown': '未知',
  'learning.accessible.title': '学习仪表板',
  'learning.accessible.welcome': '欢迎回来，{{name}}',
  'learning.accessible.voice.start': '语音',
  'learning.accessible.voice.stop': '停止语音控制',
  'learning.accessible.voice.listening': '聆听中...',
  'learning.accessible.level': '等级',
  'learning.accessible.xpToNext': '距下一等级还需 {{value}} XP',
  'learning.accessible.streak': '连续记录',
  'learning.accessible.days': '{{value}} 天',
  'learning.accessible.keepItUp': '继续加油！',
  'learning.accessible.badges': '徽章',
  'learning.accessible.achievementsEarned': '已获成就',
  'learning.accessible.tabs.overview': '概览',
  'learning.accessible.tabs.lessons': '课程',
  'learning.accessible.tabs.progress': '进度',
  'learning.accessible.tabs.achievements': '成就',
  'learning.accessible.recentActivity': '最近活动',
  'learning.accessible.noRecentActivity': '暂无最近活动',
  'learning.accessible.start': '开始',
  'learning.accessible.learningProgress': '学习进度',
  'learning.accessible.overallProgress': '总体进度',
  'learning.accessible.achievements': '成就',
  'learning.accessible.startingLesson': '开始课程 {{id}}',
  'learning.accessible.difficulty.beginner': '初级',
  'learning.accessible.difficulty.intermediate': '中级',
  'learning.accessible.difficulty.advanced': '高级',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': '连续进度',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': '课程',
  'gamification.xpToast.source.quiz': '测验',
  'gamification.xpToast.source.streak': '连续',
  'gamification.xpToast.source.badge': '徽章',
  'gamification.xpToast.source.bonus': '奖励',
  'gamification.xpToast.levelUp.title': '升级！',
  'gamification.xpToast.levelUp.description': '你已达到等级 {{level}}！',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP 获得',
  'gamification.xpToast.button.continue': '继续',
  'gamification.xpToast.streakMilestone.title': '连续里程碑！',
  'gamification.xpToast.streakMilestone.description': '达成 {{count}} 天连续记录！',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP 奖励获得',
  'gamification.close': '关闭',

  // Knowledge Base
  'knowledgeBase.back': '返回',
  'knowledgeBase.article.view': '查看',
  'knowledgeBase.article.views': '{{count}} 次浏览',
  'knowledgeBase.article.helpful': '{{count}} 人觉得有用',
  'knowledgeBase.article.notHelpful': '{{count}} 人觉得没用',
  'knowledgeBase.article.byAuthor': '作者 {{author}}',
  'knowledgeBase.header.title': '知识库',
  'knowledgeBase.header.subtitle': '找到你的问题的答案',
  'knowledgeBase.actions.filter': '筛选',
  'knowledgeBase.actions.sort': '排序',
  'knowledgeBase.search.placeholder': '搜索知识库...',
  'knowledgeBase.tabs.all': '全部',
  'knowledgeBase.stats.popular': '最受欢迎的文章',
  'knowledgeBase.stats.viewsCount': '{{count}} 次浏览',
  'knowledgeBase.stats.helpful': '最有帮助的文章',
  'knowledgeBase.stats.ratingsCount': '{{count}} 条评价',
  'knowledgeBase.stats.total': '文章总数',
  'knowledgeBase.stats.totalCount': '{{count}} 篇文章',
  'knowledgeBase.empty.title': '未找到文章',
  'knowledgeBase.empty.searching': '尝试不同的搜索词或查看分类。',
  'knowledgeBase.empty.default': '此分类暂无可用文章。',
  'knowledgeBase.difficulty.beginner': '初级',
  'knowledgeBase.difficulty.intermediate': '中级',
  'knowledgeBase.difficulty.advanced': '高级',
  'knowledgeBase.categories.odoo-basics': 'Odoo基础',
  'knowledgeBase.categories.crm': 'CRM与销售',
  'knowledgeBase.categories.inventory': '库存与采购',
  'knowledgeBase.categories.accounting': '会计',
  'knowledgeBase.categories.projects': '项目管理',
  'knowledgeBase.categories.troubleshooting': '故障排除',

  // Accounting

  // Curriculum Planning
  'curriculum.video': '视频',
  'curriculum.videoDescription': '屏幕录制或实操视频',
  'curriculum.cheatSheet': '速查表',
  'curriculum.cheatSheetDescription': '可打印，含二维码',
  'curriculum.test': '测试/测验',
  'curriculum.testDescription': 'Odoo问卷，10题，80%',
  'curriculum.checklist': '检查清单',
  'curriculum.checklistDescription': 'Odoo任务，可点击',
  'curriculum.textLesson': '文本/课程',
  'curriculum.textLessonDescription': 'Odoo课程',
  'curriculum.roleplay': '角色扮演',
  'curriculum.roleplayDescription': '与导师/Benno实时互动',
  'curriculum.practice': '实践任务',
  'curriculum.practiceDescription': '在客户处执行',

  // UI Components
  // Common Actions

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': '周概览',
  'scout.wochenplanung.previousWeek': '上一周',
  'scout.wochenplanung.nextWeek': '下一周',
  'scout.wochenplanung.toast.appointmentAdded': '已添加预约',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': '已更新预约',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': '已删除预约',
  'scout.wochenplanung.toast.slotUpdated': '已更新时段',
  'scout.wochenplanung.toast.slotUpdatedDesc': '任务已解决或时段已移除。',

  // Planning legend
  'scout.wochenplanung.legend.completed': '已完成',
  'scout.wochenplanung.legend.planned': '已计划',
  'scout.wochenplanung.legend.partial': '部分计划',
  'scout.wochenplanung.legend.unplanned': '待计划',
  'scout.wochenplanung.legend.holiday': '节假日/休假',

  // Missions section

  // Map section
  'scout.wochenplanung.dialog.deleteAppointment.title': '删除预约',
  'scout.wochenplanung.dialog.deleteAppointment.description': '确定要删除此预约吗？此操作无法撤销。',
  'scout.wochenplanung.dialog.editAppointment.title': '编辑预约',
  'scout.wochenplanung.dialog.editAppointment.description': '是否要将更改应用到此预约？',
  'scout.wochenplanung.employee': '员工',
  'scout.wochenplanung.selectEmployee': '选择员工',
  'scout.wochenplanung.allEmployees': '全部员工',
  'scout.wochenplanung.error.loading': '加载周计划时出错',
  'scout.wochenplanung.error.retry': '重试',

  // SCOUT - Mission list empty state & actions
  'scout.missionControl.tabs.team': '团队概览',
  'scout.missionControl.teamMembers': '团队成员',
  'scout.missionControl.table.employee': '员工',
  'scout.missionControl.table.team': '团队',
  'scout.missionControl.table.plzAreas': '邮编区域',

  // SCOUT - Mission Preferences

  // SCOUT - Missionen
  'scout.missionen.bestandskunden.loadError': '加载现有客户失败',
  'scout.missionen.bestandskunden.empty': '未找到现有客户',
  'scout.missionen.bestandskunden.search': '搜索现有客户...',
  'scout.missionen.bestandskunden.filteredCount': '{{total}} 个现有客户中的 {{filtered}} 个',
  'scout.missionen.wunschliste.industriesTitle': '首选行业',
  'scout.missionen.wunschliste.productsTitle': '首选产品',
  'scout.missionen.wunschliste.plzTitle': '首选邮编区域',
  'scout.missionen.wunschliste.saveButton': '保存',
  'scout.missionen.wunschliste.saved': '已保存',
  'scout.missionen.wunschliste.savedDesc': '您的偏好已保存。',
  'scout.missionen.wunschliste.saveError': '错误',
  'scout.missionen.wunschliste.saveErrorDesc': '无法保存偏好。',
  'scout.missionen.wunschliste.loadError': '加载偏好失败',
  'scout.tagesplanung.title': '日计划',
  'scout.tagesplanung.addressUnknown': '地址未知',
  'scout.tagesplanung.routeMapLabel': '路线图',
  'scout.tagesplanung.routePlanning': '路线规划',
  'scout.tagesplanung.traffic': '交通',
  'scout.tagesplanung.deferNotPossible': '无法推迟',
  'scout.tagesplanung.deferMaxReached': '今日推迟次数已达上限（3/3）。',
  'scout.tagesplanung.deferAlreadyDeferred': '此线索今日已推迟过。',
  'scout.tagesplanung.dayCannotClose': '无法关闭当日',
  'scout.tagesplanung.outstandingReports': '还有 {{count}} 份待填写的拜访报告。请先全部填写再关闭当日。',
  'scout.tagesplanung.andMore': '... 还有 {{count}} 个',
  'scout.tagesplanung.tabs.planning': '日程',
  'scout.tagesplanung.tasks.tabLabel': '任务',
  'scout.tagesplanung.tasks.empty': '暂无任务',
  'scout.tagesplanung.tasks.loading': '正在加载任务',
  'scout.tagesplanung.tasks.error': '无法加载任务',
  'scout.tagesplanung.tasks.filterFieldStatus': '状态',
  'scout.tagesplanung.tasks.filterStatusTodo': '待办',
  'scout.tagesplanung.tasks.filterStatusInProgress': '进行中',
  'scout.tagesplanung.tasks.filterStatusDone': '已完成',
  'scout.tagesplanung.tasks.priorityLabel': '优先级',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': '截止',
  'scout.tagesplanung.tasks.dueNone': '无截止时间',
  'scout.lead.neukunde': '新客户 — 利基产品作为敲门砖',
  'scout.lead.bestandskunde': '现有客户',
  'scout.metrics.besuche': '拜访',
  'scout.metrics.demos': '演示',
  'scout.metrics.auftraege': '订单',
  'scout.metrics.umsatz': '收入',
  'scout.metrics.demoRate': '演示率',
  'scout.composition.title': '任务构成',
  'scout.composition.minBestandskunden': '最少现有客户',
  'scout.composition.minQualifiziert': '最少合格线索',
  'scout.composition.maxKaltbesuche': '最多陌拜',

  // Scout daily planning
  'scout.dailyPlanning.addAppointment': '添加预约',
  'scout.dailyPlanning.appointments': '预约',
  'scout.dailyPlanning.noAppointmentsPlanned': '当日无预约',
  'scout.dailyPlanning.leadsByPriority': '线索（按优先级）',
  'scout.dailyPlanning.noLeadsPlanned': '当日无计划线索',
  'scout.dailyPlanning.skipLead': '跳过线索',
  'scout.dailyPlanning.skipLeadConfirmation': '确定要跳过此线索吗？将移至次日。',
  'scout.dailyPlanning.skip': '跳过',
  'scout.dailyPlanning.removeLead': '移除线索',
  'scout.dailyPlanning.removeLeadConfirmation': '确定要移除此线索吗？将从轮换中完全移除。',
  'scout.dailyPlanning.selectMissionToViewLeads': '选择任务以查看线索',
  'scout.dailyPlanning.selectDate': '选择日期',
  'scout.dailyPlanning.nextDay': '次日',
  'scout.dailyPlanning.closeDay': '关闭当日',
  'scout.dailyPlanning.reopenDay': '重新打开当日',
  'scout.dailyPlanning.noAcceptedLeads': '当日无已接受线索。',
  'scout.dailyPlanning.statusSkipped': '已跳过',
  'scout.dailyPlanning.selectAll': '全选',
  'scout.dailyPlanning.selectAllLeads': '全选线索',
  'scout.dailyPlanning.noSuggestions': '无建议。',
  'scout.dailyPlanning.previousDay': '前一天',
  'scout.dailyPlanning.calendarWeek': '第 {{weekNumber}} 周',
  'scout.dailyPlanning.visit': '拜访',
  'scout.dailyPlanning.details': '详情',
  'scout.dailyPlanning.missionsLoading': '正在加载任务…',
  'scout.dailyPlanning.leadsLoading': '正在加载线索…',
  'scout.dailyPlanning.noLeadsFound': '未找到线索',
  'scout.dailyPlanning.moreLeads': '更多',
  'scout.dailyPlanning.dailyList': '当日列表',
  'scout.dailyPlanning.unknown': '未知',
  'scout.dailyPlanning.suggestedLeads': '推荐线索',
  'scout.dailyPlanning.error': '错误：{{error}}',
  'scout.dailyPlanning.help': '帮助',
  'scout.dailyPlanning.bulkActions': '批量操作',
  'scout.dailyPlanning.actionsCount': '操作（{{count}}）',
  'scout.dailyPlanning.accept': '接受',
  'scout.dailyPlanning.reject': '拒绝',
  'scout.dailyPlanning.selectLead': '选择线索 {{name}}',
  'scout.dailyPlanning.openLeadDetails': '打开 {{name}} 的详情',
  'scout.dailyPlanning.score': '评分：{{score}}',
  'scout.dailyPlanning.loading': '正在加载日计划',
  // Scout weekly planning
  // Scout scorecard
  'scout.scorecard.selectHeatmapMetric': '选择热力图指标',
  'scout.scorecard.orders': '订单',
  'scout.scorecard.annualTargetOrders': '年度订单目标',
  'scout.scorecard.comingSoon': '即将推出',
  'scout.scorecard.kpiOverview': 'KPI 概览、活动与重点行业',
  'scout.scorecard.activityByDay': '按日统计活动',
  'scout.scorecard.title': '记分卡',
  'scout.scorecard.period.tag': '日',
  'scout.scorecard.period.woche': '周',
  'scout.scorecard.period.monat': '月',
  'scout.scorecard.period.jahr': '年',
  'scout.scorecard.kpiTilesHeading': 'KPI 卡片',
  'scout.scorecard.topBranchenProdukteHeading': '重点行业与重点产品',
  'scout.scorecard.soll': '目标',
  'scout.scorecard.forecast': '预测',
  'scout.scorecard.gapToGo': '待完成差距',
  'scout.scorecard.csvExport': '导出 CSV',
  'scout.scorecard.pdfExport': '导出 PDF',
  'scout.scorecard.table.date': '日期',
  'scout.scorecard.table.visits': '拜访',
  'scout.scorecard.table.demos': '演示',
  'scout.scorecard.table.orders': '订单',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': '净收入',
  'scout.scorecard.table.total': '合计',
  'scout.scorecard.topBranchen': '重点行业',
  'scout.scorecard.topProdukte': '重点产品',
  'scout.scorecard.table.industry': '行业',
  'scout.scorecard.table.quantity': '数量（件）',
  'scout.scorecard.table.revenue': '收入（€）',
  'scout.scorecard.table.product': '产品',
  'scout.scorecard.table.salesVolume': '销量',
  'scout.scorecard.table.customers': '客户',
  'scout.scorecard.kpi.visits': '拜访',
  'scout.scorecard.kpi.demos': '演示',
  'scout.scorecard.kpi.orders': '订单',
  'scout.scorecard.kpi.netRevenue': '净收入',
  'scout.scorecard.kpi.gebinde60l': '60L 件',
  'scout.scorecard.kpi.gebinde25l': '25L 件',
  'scout.scorecard.kpi.gebinde10l': '10L 件',
  'scout.scorecard.emptyTitle': '暂无数据',
  'scout.scorecard.emptyDescription': '所选时间段暂无 KPI 数据。',
  'scout.scorecard.missionPerformanceTitle': '任务表现',
  'scout.scorecard.missionMissionsCompleted': '已完成任务',
  'scout.scorecard.missionConversionRate': '转化率',
  'scout.scorecard.missionTerritoryCoverage': '区域覆盖',
  'scout.scorecard.viewMissionDetails': '查看详情',
  'scout.scorecard.adjustTargets': '调整目标',
  'scout.scorecard.annualTarget': '年度目标',
  'scout.scorecard.annualTargetVisits': '年度拜访目标',
  'scout.scorecard.annualTargetDemos': '年度演示目标',
  'scout.scorecard.annualTargetNetRevenue': '净收入（€）',
  'scout.scorecard.annualTargetNetRevenueA11y': '年度净收入目标（欧元）',
  'scout.scorecard.monthlyOverrides': '月度覆盖',
  'scout.scorecard.table.month': '月份',
  'scout.scorecard.table.reason': '原因',
  'scout.scorecard.derivedTargets': '派生目标',
  'scout.scorecard.dailyTargetLabel': '日目标：{{count}} 次拜访',
  'scout.scorecard.weeklyTargetLabel': '周目标：{{count}} 次拜访',
  'scout.scorecard.save': '保存',
  'scout.scorecard.heatmap.visits': '拜访',
  'scout.scorecard.heatmap.demos': '演示',
  'scout.scorecard.heatmap.revenue': '收入',
  'scout.scorecard.heatmap.low': '低',
  'scout.scorecard.heatmap.high': '高',
  'scout.scorecard.heatmap.scaleA11y': '从低到高的颜色刻度',
  'scout.scorecard.heatmap.loading': '正在加载地图…',
  // Scout mission control
  'scout.missionControl.teamOverview': '您的团队及其邮编区域',
  'scout.missionControl.jokerLimitPerDay': '每日王牌限额',
  'scout.missionControl.jokerLimitUpdated': '王牌限额已更新。',
  'scout.missionControl.jokerLimitSaveFailed': '无法保存王牌限额。',
  'scout.missionControl.selectTeam': '选择团队',
  'scout.missionControl.none': '无',
  'scout.missionControl.addPlzAreaFor': '为以下添加邮编区域',
  'scout.missionControl.addPlzArea': '添加邮编区域',
  'scout.missionControl.noTeamMembersFound': '未找到团队成员。',
  'scout.missionControl.orders': '订单',
  'scout.missionControl.resetSettings': '重置设置',
  'scout.missionControl.saveSettings': '保存设置',
  'scout.missionControl.territorySaturation': '区域饱和度（邮编）',
  'scout.missionControl.day': '日',
  'scout.missionControl.selectDay': '选择日期',
  'scout.missionControl.week': '周',
  'scout.missionControl.selectWeek': '选择周',
  'scout.missionControl.month': '月',
  'scout.missionControl.selectMonth': '选择月',
  'scout.missionControl.planFulfillment': '计划完成率',
  'scout.missionControl.plzPrefixPlaceholder': '邮编前缀（如 70）',
  'scout.missionControl.plzPrefix': '邮编前缀',
  'scout.missionControl.addPlzToWhitelist': '将邮编前缀加入白名单',
  'scout.missionControl.addPlzToGreylist': '将邮编前缀加入灰名单',
  'scout.missionControl.addPlzToYellowlist': '将邮编前缀加入黄名单',
  'scout.missionControl.addNewTeamMember': '添加新成员',
  'scout.missionControl.lastModified': '最后修改',
  'scout.missionControl.outsideAreaRules': '区域外规则',
  'scout.missionControl.outsidePlzPolicy': '名单外邮编策略',
  'scout.missionControl.enableOutsideWarning': '启用区域外邮编警告',
  'scout.missionControl.requireOutsideApproval': '区域外邮编需审批',
  'scout.missionControl.rejectOutsidePlz': '拒绝区域外邮编',
  'scout.missionControl.checkPlz': '检查邮编或邮编前缀',
  'scout.missionControl.check': '检查',
  'scout.missionControl.error': '错误',
  'scout.missionControl.success': '成功',
  'scout.missionControl.userProfileNotFound': '未找到用户资料',
  'scout.missionControl.plzAreasUpdated': '邮编区域已更新',
  'scout.missionControl.plzAreasSaveFailed': '无法保存邮编区域',

  // Mission Control → Config → KPI Target Configuration (MC-004)

  // Scout Mission Control — Rep Config (T13)
  'scout.missionControl.repConfig.title': '代表配置',
  'scout.missionControl.repConfig.repName': '姓名/邮箱',
  'scout.missionControl.repConfig.industries': '行业',
  'scout.missionControl.repConfig.products': '产品',
  'scout.missionControl.repConfig.plz': '邮编',
  'scout.missionControl.repConfig.loadError': '无法加载代表配置',
  'scout.missionControl.repConfig.saveError': '保存失败',
  'scout.missionControl.repConfig.savedTitle': '已保存',
  'scout.missionControl.repConfig.savedDesc': '代表配置已更新',

  // Scout Mission Control — Joker Limit (T16)
  'scout.missionControl.jokerConfig.title': '每日王牌限额',
  'scout.missionControl.jokerConfig.description': '每位代表每天最多使用王牌次数。',
  'scout.missionControl.jokerConfig.maxPerDay': '每日最多',
  'scout.missionControl.jokerConfig.loadError': '无法加载王牌配置',
  'scout.missionControl.jokerConfig.saveError': '保存失败',
  'scout.missionControl.jokerConfig.savedTitle': '已保存',
  'scout.missionControl.jokerConfig.savedDesc': '王牌限额已更新',

  // Scout session (NAV-005)

  // Scout Mission Control — territories (MC-001, MC-002)

  // Scout Mission Control — diagnostics (MC-006)
  'scout.missionControl.diagnostics.demoRate': '演示率',
  'scout.missionControl.diagnostics.visitDepth': '拜访深度',

  // Scout Unternehmenssuche
  'scout.unternehmenssuche.selectAllResults': '选择全部搜索结果',
  'scout.unternehmenssuche.openingHours': '营业时间',
  'scout.unternehmenssuche.temporarilyClosed': '临时关闭',
  'scout.unternehmenssuche.startSearch': '开始搜索',
  'scout.unternehmenssuche.searchRunning': '搜索中...',
  'scout.unternehmenssuche.adjustSearchCriteria': '请调整搜索条件或重试。',
  'scout.unternehmenssuche.selectCompanyType': '选择企业类型',
  'scout.unternehmenssuche.openingHoursTime': '营业时间',
  'scout.unternehmenssuche.noTimeNeeded': '无需时间',
  'scout.unternehmenssuche.addConditions': '添加条件以缩小搜索范围',
  'scout.unternehmenssuche.addCondition': '添加条件',
  'scout.unternehmenssuche.addGroup': '添加分组',
  'scout.unternehmenssuche.savedSearchName': '已保存搜索名称',
  'scout.unternehmenssuche.saveCurrentSearch': '保存当前搜索',
  'scout.unternehmenssuche.savedSearches': '已保存搜索',
  'scout.unternehmenssuche.noSavedSearches': '暂无已保存搜索。',
  'scout.unternehmenssuche.keywordPlaceholder': '如：餐厅、酒吧、面包店',
  'scout.unternehmenssuche.addWaypoint': '添加途经点',
  'scout.unternehmenssuche.locationPlaceholder': '如：慕尼黑玛丽亚广场',
  'scout.unternehmenssuche.toggleAdditionalFilters': '显示或隐藏更多筛选',
  'scout.unternehmenssuche.additionalFilters': '更多筛选',
  'scout.unternehmenssuche.saveSearchAsFile': '将搜索另存为文件',
  'scout.unternehmenssuche.loadSearchFromFile': '从文件加载搜索',
  'scout.unternehmenssuche.checkSearchTerms': '请检查搜索词或重试。',

  // Search overlay
  'search.overlay.hint': '输入后按 Enter 或点击搜索。',
  'search.overlay.placeholder': '搜索 (/) 资源、文档等',
  'search.overlay.searchLabel': '搜索',
  'search.overlay.noResults': '未找到“{{query}}”的结果',
  'search.overlay.tryDifferent': '换用其他关键词或检查拼写。',
  'search.overlay.topResults': '热门结果',
  'search.overlay.documentation': '文档 · ',

  // Location/Route toggle (Unternehmenssuche)
  'scout.unternehmenssuche.locationRadius': '地点 + 半径',
  'scout.unternehmenssuche.routeCorridor': '路线 + 走廊',
  'scout.unternehmenssuche.withoutLocation': '无地点',

  // Scout missions (Wave 3 i18n)
  'scout.scorecard.heatmapTitle': '活动热力图（邮编-2）',
  'scout.preferences.defaultRegionLabel': '默认区域',
  'scout.preferences.selectRegionPlaceholder': '选择区域',
  'scout.preferences.defaultStatusLabel': '默认状态',
  'scout.preferences.selectDefaultStatus': '选择默认状态',
  'scout.preferences.statusDraft': '草稿',
  'scout.preferences.statusActive': '进行中',
  'scout.preferences.statusCompleted': '已完成',
  'scout.preferences.statusArchived': '已归档',
  'scout.preferences.saving': '保存中...',
  'scout.preferences.plzPrefixes': '任务邮编前缀',
  'scout.preferences.plzPrefixesPlaceholder': '输入逗号分隔的邮编前缀（如 70, 71, 72）',
  'scout.preferences.maxRouteLength': '最大路线长度（公里）',
  'scout.preferences.maxRouteLengthDescription': '最大路线长度（公里）',
  'scout.preferences.autoGenerateMissions': '自动生成任务（夜间自动化）',
  'scout.preferences.autoGenerateDescription': '启用后，将根据您的设置自动生成任务。',
  'scout.preferences.defaultAssigneeLabel': '默认负责人',
  'scout.preferences.defaultAssigneePlaceholder': '输入默认负责人',
  'scout.preferences.defaultAssigneeAria': '默认负责人',
  'scout.preferences.defaultLeadCountLabel': '默认线索数',
  'scout.preferences.defaultLeadCountAria': '默认线索数',
  'scout.preferences.defaultDurationLabel': '默认时长（天）',
  'scout.preferences.defaultDurationAria': '默认时长（天）',
  'scout.preferences.autoAssignLabel': '自动将任务分配给默认负责人',
  'scout.preferences.productFamiliesLabel': '产品系列',
  'scout.preferences.industryCodesLabel': '行业',
  'scout.preferences.keywordsLabel': '关键词',
  'scout.preferences.keywordsPlaceholder': '如：混凝土、地坪',
  'scout.preferences.minLeadsLabel': '每任务最少线索数',
  'scout.preferences.minLeadsAria': '每任务最少线索数',
  'scout.preferences.maxLeadsLabel': '每任务最多线索数',
  'scout.preferences.maxLeadsAria': '每任务最多线索数',
  'scout.preferences.dailyQuotaLabel': '每日任务数',
  'scout.preferences.dailyQuotaAria': '每日最多任务数',
  'scout.preferences.dailyQuotaHelper': '每日自动生成任务上限（1–3）',
  'scout.dailyPlanning.inField': '外勤中',
  'scout.dailyPlanning.completed': '已完成',
  'scout.dailyPlanning.openDay': '打开当日',
  'scout.dailyPlanning.dayMarkedCompleted': '当日已标记为完成。',
  'scout.dailyPlanning.statusVisited': '已拜访',
  'scout.dailyPlanning.statusPlanned': '已计划',
  'scout.dailyPlanning.statusCompleted': '已完成',
  'scout.createMission.title': '创建新任务',
  'scout.createMission.description': '选择名称、筛选与分配',
  'scout.createMission.nameLabel': '名称',
  'scout.createMission.nameRequired': '名称为必填项',
  'scout.createMission.namePlaceholder': '如：斯图加特北 — 制冷设备',
  'scout.createMission.nameAria': '任务名称',
  'scout.createMission.regionLabel': '区域（可选）',
  'scout.createMission.regionPlaceholder': '如：邮编 70xxx',
  'scout.createMission.regionAria': '区域或邮编',
  'scout.createMission.ownerLabel': '负责人',
  'scout.createMission.ownerPlaceholder': '邮箱地址',
  'scout.createMission.ownerAria': '负责人邮箱',
  'scout.createMission.themeLabel': '主题（可选）',
  'scout.createMission.themePlaceholder': '如：制冷设备',
  'scout.createMission.themeAria': '任务主题',
  'scout.createMission.productLabel': '产品（可选）',
  'scout.createMission.productPlaceholder': '如：K-2000',
  'scout.createMission.productAria': '产品',
  'scout.createMission.cancel': '取消',
  'scout.createMission.save': '保存',
  'scout.createMission.saveBusy': '保存中…',
  'scout.createMission.cancelAria': '取消创建任务',
  'scout.createMission.saveAria': '保存任务',
  'scout.createMission.saveBusyAria': '正在保存任务',

  // Inventory

  // Sales

  // Purchase


  // Settings
  'settings.description': '管理应用设置与自定义选项',
  'settings.typography.title': '排版',
  'settings.typography.description': '调整字号与密度以提升可读性或信息密度',
  'settings.typography.scale.title': '字号',
  'settings.typography.scale.description': '标准对应主基准；舒适模式增大字号以适合长时间使用',
  'settings.typography.scale.ariaLabel': '字号预设',
  'settings.typography.scale.compact': '紧凑',
  'settings.typography.scale.standard': '标准',
  'settings.typography.scale.comfort': '舒适',
  'settings.tabs.appearance': '外观',
  'settings.tabs.account': '账户',
  'settings.tabs.notifications': '通知',
  'settings.tabs.security': '安全',
  'settings.language.title': '语言设置',
  'settings.language.description': '选择界面语言',
  'settings.language.interfaceLanguage': '界面语言',
  'settings.language.interfaceLanguageDesc': '选择菜单、按钮与界面元素的语言',
  'settings.theme.title': '配色',
  'settings.theme.description': '自定义界面外观与颜色',
  'settings.theme.predefinedThemes': '是否从 10 个预设主题中选择？',
  'settings.theme.goToThemeSettings': '前往主题设置',
  'settings.themeSettings.title': '主题设置',
  'settings.themeSettings.description': '使用预设主题自定义应用外观',
  'settings.themeSettings.themeDetails': '主题详情',
  'settings.themeSettings.themeId': '主题 ID：',
  'settings.themeSettings.colorScheme': '配色：',
  'settings.account.profile.title': '个人资料',
  'settings.account.profile.description': '更新您的个人信息与账户资料',
  'settings.account.profile.name': '姓名',
  'settings.account.profile.email': '邮箱',
  'settings.account.profile.role': '角色',
  'settings.account.profile.department': '部门',
  'settings.account.profile.editProfile': '编辑资料',
  'settings.account.data.title': '数据管理',
  'settings.account.data.description': '管理数据同步与备份设置',
  'settings.account.data.cloudSync': '云同步',
  'settings.account.data.cloudSyncEnabled': '您的设置将同步到云端',
  'settings.account.data.cloudSyncDisabled': '云同步已关闭（功能开关）',
  'settings.account.data.syncNow': '立即同步',
  'settings.notifications.title': '通知设置',
  'settings.notifications.description': '配置接收通知的方式',
  'settings.notifications.email.title': '邮件通知',
  'settings.notifications.email.description': '通过邮件接收通知',
  'settings.notifications.push.title': '推送通知',
  'settings.notifications.push.description': '在浏览器中接收推送通知',
  'settings.notifications.system.title': '系统告警',
  'settings.notifications.system.description': '重要系统通知',
  'settings.notifications.configure': '配置',
  'settings.security.title': '安全设置',
  'settings.security.description': '管理账户安全与隐私设置',
  'settings.security.password.title': '密码',
  'settings.security.password.lastChanged': '30 天前修改',
  'settings.security.password.change': '修改',
  'settings.security.twoFactor.title': '双因素认证',
  'settings.security.twoFactor.description': '增加一层安全保护',
  'settings.security.twoFactor.enable': '启用',
  'settings.security.sessions.title': '会话管理',
  'settings.security.sessions.description': '管理活跃会话',
  'settings.security.sessions.view': '查看会话',
  'settings.company.title': '企业设置',
  'settings.company.description': '管理企业信息与设置',
  'settings.company.edit': '编辑企业',
  'settings.company.saveChanges': '保存更改',
  'settings.company.cancel': '取消',
  'settings.company.tabs.general': '通用',
  'settings.company.tabs.contact': '联系',
  'settings.company.tabs.billing': '账单',
  'settings.company.tabs.branding': '品牌',
  'settings.company.general.companyInfo': '企业信息',
  'settings.company.general.companyName': '公司名称',
  'settings.company.general.legalName': '法定名称',
  'settings.company.general.taxId': '税号',
  'settings.company.general.registrationNumber': '注册号',
  'settings.company.general.industry': '行业',
  'settings.company.general.foundedYear': '成立年份',
  'settings.company.general.employees': '员工数',
  'settings.company.general.industry.technology': '技术',
  'settings.company.general.industry.manufacturing': '制造',
  'settings.company.general.industry.retail': '零售',
  'settings.company.general.industry.healthcare': '医疗',
  'settings.company.general.industry.finance': '金融',
  'settings.company.general.industry.other': '其他',
  'settings.company.address.title': '地址信息',
  'settings.company.address.street': '街道',
  'settings.company.address.city': '城市',
  'settings.company.address.state': '省/州',
  'settings.company.address.zipCode': '邮编',
  'settings.company.address.country': '国家',
  'settings.company.address.country.us': '美国',
  'settings.company.address.country.ca': '加拿大',
  'settings.company.address.country.uk': '英国',
  'settings.company.address.country.de': '德国',
  'settings.company.address.country.fr': '法国',
  'settings.company.address.country.other': '其他',
  'settings.company.contact.title': '联系信息',
  'settings.company.contact.phone': '电话',
  'settings.company.contact.email': '邮箱',
  'settings.company.contact.website': '网站',
  'settings.company.contact.supportEmail': '支持邮箱',
  'settings.company.billing.title': '账单设置',
  'settings.company.billing.currency': '货币',
  'settings.company.billing.taxRate': '税率（%）',
  'settings.company.billing.paymentTerms': '付款条款',
  'settings.company.billing.billingCycle': '账单周期',
  'settings.company.billing.paymentTerms.net15': '净 15',
  'settings.company.billing.paymentTerms.net30': '净 30',
  'settings.company.billing.paymentTerms.net45': '净 45',
  'settings.company.billing.paymentTerms.net60': '净 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': '收到即付',
  'settings.company.billing.cycle.monthly': '月付',
  'settings.company.billing.cycle.quarterly': '季付',
  'settings.company.billing.cycle.annually': '年付',
  'settings.company.billing.cycle.custom': '自定义',
  'settings.company.billing.summary.title': '账单摘要',
  'settings.company.billing.summary.currentPlan': '当前方案',
  'settings.company.billing.summary.monthlyCost': '月费',
  'settings.company.billing.summary.nextBillingDate': '下次账单日',
  'settings.company.billing.summary.paymentMethod': '付款方式',
  'settings.company.billing.summary.status': '状态',
  'settings.company.billing.summary.active': '有效',
  'settings.company.branding.title': '品牌与外观',
  'settings.company.branding.logo': '企业 Logo',
  'settings.company.branding.uploadLogo': '上传 Logo',
  'settings.company.branding.logoHint': 'PNG、JPG，最大 2MB',
  'settings.company.branding.favicon': '网站图标',
  'settings.company.branding.uploadFavicon': '上传网站图标',
  'settings.company.branding.faviconHint': 'ICO、PNG，最大 1MB',
  'settings.company.branding.primaryColor': '主色',
  'settings.company.branding.secondaryColor': '辅色',
  'settings.usersRoles.stats.totalUsers': '用户总数',
  'settings.usersRoles.stats.activeUsers': '活跃用户',
  'settings.usersRoles.stats.totalRoles': '角色总数',
  'settings.usersRoles.stats.roleConfigurations': '角色配置',
  'settings.userManagement.title': '用户管理',
  'settings.userManagement.description': '管理用户、角色与系统设置',
  'settings.userManagement.addUser': '添加用户',
  'settings.userManagement.editUser': '编辑用户',
  'settings.userManagement.createNewUser': '创建新用户',
  'settings.userManagement.updateUserInfo': '更新用户信息',
  'settings.userManagement.addNewUser': '向系统添加新用户',
  'settings.userManagement.tabs.users': '用户',
  'settings.userManagement.tabs.appAccess': '应用访问',
  'settings.userManagement.tabs.roles': '角色',
  'settings.userManagement.toast.userCreated': '用户创建成功',
  'settings.userManagement.toast.userUpdated': '用户更新成功',
  'settings.userManagement.toast.userDeleted': '用户删除成功',
  'settings.userManagement.toast.roleCreated': '角色创建成功',
  'settings.userManagement.toast.roleUpdated': '角色更新成功',
  'settings.userManagement.toast.roleDeleted': '角色删除成功',
  'settings.userManagement.toast.error': '无法创建用户',
  'settings.userManagement.toast.errorUpdate': '无法更新用户',
  'settings.userManagement.toast.errorDelete': '无法删除用户',
  'settings.userManagement.toast.errorRoleCreate': '无法创建角色',
  'settings.userManagement.toast.errorRoleUpdate': '无法更新角色',
  'settings.userManagement.toast.errorRoleDelete': '无法删除角色',
  'settings.integrations.settings.security.enabled': '已启用',
  'settings.integrations.settings.security.disabled': '已禁用',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'CRM 联系人',
  'crm.contacts.description': '管理客户与供应商联系人及地址',
  'crm.contacts.add': '添加联系人',
  'crm.contacts.edit': '编辑联系人',
  'crm.contacts.delete': '删除联系人',
  'crm.contacts.view360': '360° 视图',
  'crm.contacts.unassigned': '未分配',
  'crm.contacts.type.customer': '客户',
  'crm.contacts.type.supplier': '供应商',
  'crm.contacts.type.partner': '合作伙伴',
  'crm.contacts.type.prospect': '潜在客户',
  'crm.contacts.status.active': '活跃',
  'crm.contacts.status.inactive': '未激活',
  'crm.contacts.status.suspended': '已暂停',
  'crm.contacts.validation.companyRequired': '公司名称为必填项',
  'crm.contacts.validation.streetRequired': '街道为必填项',
  'crm.contacts.validation.postalRequired': '邮编为必填项',
  'crm.contacts.validation.cityRequired': '城市为必填项',
  'crm.contacts.validation.countryRequired': '国家为必填项',
  'crm.contacts.validation.nameRequired': '联系人为必填项',
  'crm.contacts.validation.emailInvalid': '邮箱格式无效',
  'crm.contacts.validation.phoneRequired': '电话为必填项',
  'crm.contacts.validation.salesPersonRequired': '销售为必填项',
  'crm.contacts.validation.ordererNameRequired': '订货人为必填项',
  'crm.contacts.validation.roleRequired': '角色为必填项',
  'crm.contacts.validation.hoursRequired': '工时为必填项',
  'crm.openMenu': '打开菜单',

  // CRM - Leads
  'crm.leads.title': '线索',
  'crm.leads.description': '管理销售线索并跟踪转化',
  'crm.leads.add': '添加线索',
  'crm.leads.edit': '编辑线索',
  'crm.leads.delete': '删除线索',
  'crm.leads.status.new': '新线索',
  'crm.leads.status.contacted': '已联系',
  'crm.leads.status.qualified': '已确认',
  'crm.leads.status.proposal': '报价',
  'crm.leads.status.negotiation': '谈判中',
  'crm.leads.status.closedWon': '已成交',
  'crm.leads.status.closedLost': '已流失',
  'crm.leads.source.website': '网站',
  'crm.leads.source.referral': '推荐',
  'crm.leads.source.email': '邮件',
  'crm.leads.source.phone': '电话',
  'crm.leads.source.social': '社交媒体',
  'crm.leads.source.other': '其他',
  'crm.leads.value': '价值',
  'crm.leads.lastContact': '最后联系',
  'crm.leads.notes': '备注',
  'crm.leads.search': '搜索线索...',
  'crm.leads.filterByStatus': '按状态筛选',
  'crm.leads.filterBySource': '按来源筛选',
  'crm.leads.totalLeads': '线索总数',
  'crm.leads.pipelineValue': '管道价值',
  'crm.leads.qualifiedLeads': '合格线索',

  // Visit Report
  'visitReport.title': '拜访报告',
  'visitReport.createTitle': '创建拜访报告',
  'visitReport.titleFor': '{{name}} 的拜访报告',
  'visitReport.visitType': '拜访类型',
  'visitReport.coldVisit': '陌拜',
  'visitReport.appointment': '预约',
  'visitReport.salesOutcome': '销售结果',
  'visitReport.noContact': '未联系',
  'visitReport.conversation': '交谈',
  'visitReport.demo': '演示',
  'visitReport.order': '订单',
  'visitReport.orderValue': '订单金额（欧元）',
  'visitReport.nextStep': '下一步',
  'visitReport.callback': '回访',
  'visitReport.sendOffer': '发送报价',
  'visitReport.revisit': '再次拜访',
  'visitReport.completed': '已完成',
  'visitReport.appointmentWindow': '预约时段（可选）',
  'visitReport.from': '开始',
  'visitReport.to': '结束',
  'visitReport.contactName': '联系人姓名',
  'visitReport.enterName': '输入姓名',
  'visitReport.roleFunction': '职位/角色',
  'visitReport.enterRole': '输入职位',
  'visitReport.isDecisionMaker': '是否决策人？',
  'visitReport.decisionMakerName': '决策人姓名',
  'visitReport.decisionMakerRole': '决策人职位',
  'visitReport.email': '邮箱（可选）',
  'visitReport.phone': '电话（可选）',
  'visitReport.notes': '备注（可选）',
  'visitReport.additionalInfo': '补充信息...',
  'visitReport.productsDiscussed': '是否讨论产品？',
  'visitReport.annualDemand': '年需求',
  'visitReport.select': '选择',
  'visitReport.interest': '兴趣',
  'visitReport.interestHigh': '高',
  'visitReport.interestMedium': '中',
  'visitReport.interestLow': '低',
  'visitReport.modelFeedback': '系统推荐是否合适？',
  'visitReport.feedbackYes': '是',
  'visitReport.feedbackPartially': '部分',
  'visitReport.feedbackNo': '否',
  'visitReport.feedbackNotSeen': '未看到',
  'visitReport.branchCorrect': '行业是否正确？（可选）',
  'visitReport.selectBranch': '选择行业',
  'visitReport.branchConstruction': '建筑',
  'visitReport.branchIndustry': '工业',
  'visitReport.branchTrade': '贸易',
  'visitReport.branchService': '服务',
  'visitReport.noInterestReason': '无兴趣原因',
  'visitReport.wrongProduct': '产品不对',
  'visitReport.wrongTiming': '时机不对',
  'visitReport.existingSupplier': '已有供应商',
  'visitReport.noBudget': '无预算',
  'visitReport.noNeed': '无需求',
  'visitReport.decisionMakerNotReached': '未接触到决策人',
  'visitReport.additionalRemarks': '其他备注（可选）',
  'visitReport.error': '错误',
  'visitReport.validationError': '请选择拜访类型和销售结果。',
  'visitReport.deferralNotPossible': '无法推迟',
  'visitReport.maxDeferralReached': '您已推迟过最后一次报告。请填写本报告。',
  'visitReport.reportDeferred': '报告已推迟',
  'visitReport.deferralMessage': '您可以稍后填写报告。',
  'visitReport.reportCreated': '拜访报告已创建',
  'visitReport.reportSaved': '拜访报告已保存。',
  'visitReport.reportSavedFor': '{{name}} 的拜访报告已保存。',
  'visitReport.reportError': '无法创建拜访报告。',
  'visitReport.stepOf': '第 {{current}} 步，共 {{total}} 步',
  'visitReport.back': '返回',
  'visitReport.cancel': '取消',
  'visitReport.inAHurry': '我赶时间',
  'visitReport.next': '下一步',
  'visitReport.saving': '保存中...',
  'visitReport.finishVisit': '完成拜访',
  'visitReport.contactNotes': '联系人补充信息...',
  'visitReport.callingQueue.prompt': '是否为此线索准备 AI 预约通话？',
  'visitReport.callingQueue.yes': '是，加入队列',
  'visitReport.callingQueue.no': '否',
  'visitReport.callingQueue.toast': '线索已加入呼叫队列。',

  // --- SS-145: admin ---

  // --- SS-145: learning ---

  // --- SS-145: modals ---
  'modals.assignMissionModal.close': '关闭',
  'modals.assignMissionModal.searchPlaceholder': '搜索（标题/行业）',
  'modals.assignMissionModal.searchAriaLabel': '搜索',
  'modals.missionQuickViewModal.description': '任务简要概览。查看详情请打开任务页。',
  'modals.missionQuickViewModal.close': '关闭',
  'modals.missionQuickViewModal.openDetails': '打开详情',
  'modals.missionQuickViewModal.openDetailsAria': '打开任务详情',
  'modals.leadDetailModal.close': '关闭',
  'modals.leadDetailModal.whoIsThis': '这是谁？',
  'modals.leadDetailModal.whatDoTheyNeed': '他们需要什么？',
  'modals.leadDetailModal.whatDoISay': '我该说什么？',
  'modals.leadDetailModal.moreProducts': '更多产品',
  'modals.regionDetailsModal.description': '任务详情概览。此视图为只读。',
  'modals.regionDetailsModal.edit': '编辑',
  'modals.regionDetailsModal.close': '关闭',
  'modals.editRegionModal.close': '关闭',
  'modals.editRegionModal.description': '编辑任务的时间与备注。状态为只读。',
  'modals.editRegionModal.statusReadonlySrOnly': '状态为只读。',
  'modals.splitAssignmentDialog.actionLabel': '选择操作',
  'modals.splitAssignmentDialog.confirmButton': '确认',
  'modals.addAppointmentModal.companyAriaLabel': '选择或输入公司/线索',
  'modals.addAppointmentModal.commitmentConfirmed': '已确认',
  'modals.rejectLead.title': '拒绝线索',
  'modals.rejectLead.closeAria': '关闭对话框',
  'modals.rejectLead.description': '请至少选择一个拒绝原因。',
  'modals.rejectLead.reasonsLabel': '拒绝原因',
  'modals.rejectLead.reasonsError': '请至少选择一个原因。',
  'modals.rejectLead.otherReasonLabel': '其他原因',
  'modals.rejectLead.otherReasonPlaceholder': '请描述原因...',
  'modals.rejectLead.otherReasonAria': '其他拒绝原因',
  'modals.rejectLead.otherReasonError': '请输入原因。',
  'modals.rejectLead.cancel': '取消',
  'modals.rejectLead.confirm': '拒绝（{count}）',
  'modals.rejectLead.reason.outOfBusiness': '已停业',
  'modals.rejectLead.reason.temporarilyClosed': '临时关闭',
  'modals.rejectLead.reason.knownAndUnsuitable': '已知且不合适',
  'modals.rejectLead.reason.noInterest': '无兴趣',
  'modals.rejectLead.reason.wrongContact': '联系人错误',
  'modals.rejectLead.reason.other': '其他',

  'app.routes.loadingSettings': '正在加载设置...',
  'companySearch.filters.companySize': '企业规模',
  'curriculum.modules.pillar': '支柱',
  'curriculum.modules.selectLevel': '选择等级',
  'curriculum.modules.selectPillar': '选择支柱',
  'curriculum.modules.selectPillarOption': '选择支柱',
  'learning.lessonViewer.audioNotSupported': '您的浏览器不支持音频。',
  'learning.lessonViewer.complete': '完成',
  'learning.lessonViewer.formatNotSupported': '不支持该格式',
  'learning.lessonViewer.videoNotSupported': '您的浏览器不支持视频。',
  'learning.moduleEditor.pillar': '支柱',
  'learning.moduleEditor.pillarLabel': '支柱',
  'learning.tabs.availableLessons': '可用课程',
  'learning.tabs.availableQuizzes': '可用测验',
  'missions.management.demoPerformed': '已做演示',
  'missions.management.demoPerformedLabel': '已做演示',
  'missions.management.kpiDescription': '接触决策人、演示、收入',
  'missions.management.moreActions': '更多任务操作',
  'missions.management.publish': '发布',
  'missions.management.searchPlaceholder': '搜索（名称/区域/主题/产品）',
  'mobile.layout.closeMenu': '关闭菜单',
  'mobile.layout.menu': '菜单',
  'mobile.layout.noOfflineContent': '无离线内容',
  'mobile.layout.offlinePerformance': '离线体验更佳',
  'navigation.tileCard.openActions': '打开图块操作',
  'scout.preferences.badenWuerttemberg': '巴登-符腾堡',
  'scout.preferences.thueringen': '图林根',
  'scout.sprints.ciEstimate': 'CI 运行时间估算',
  'scout.sprints.estimatedMinutes': '预计分钟数',
  'styleGuide.charts.noStatusColors': '图表不得使用状态色',
  'styleGuide.confirmation': '确认',
  'styleGuide.description': '描述',
  'styleGuide.statusSemantics.success': '成功 = 已完成/正常',
  'tickets.list.filterPriority': '按优先级筛选',
  'ui.calendar.nextMonth': '下月',
  'ui.errorBoundary.returnToDashboard': '返回仪表板',
  'ui.impersonation.selectImpersonation': '选择代管',
  'ui.impersonation.selectUser': '选择用户：',
  'ui.routingPreview.openAppleMaps': '在 Apple 地图中打开',
  'ui.routingPreview.openGoogleMaps': '在 Google 地图中打开',
  'ui.routingPreview.stopsLabel': '{{count}} 站 · {{distance}} 公里 · {{time}} 分钟（预计）',
  'ui.routingPreview.title': '路线预览',
  'weeklyPlanning.appointmentModal.additionalNotes': '附加备注',
  'weeklyPlanning.legacyAppointments.addAppointment': '添加预约',
  'scout.help.selectArticle': '在左侧选择文章或使用搜索打开帮助文章。',

  // Visit Report — Rejection Sheet (B1)

  // Visit Report — Post-Visit Report (B2)

  // Visit Report — Compliance Gate (B3)
  'scout.visitReport.compliance.title': '待填拜访报告',
  'scout.visitReport.compliance.description': '您有 {{count}} 份待填拜访报告。请先填写。',
  'scout.visitReport.compliance.lockoutTitle': '需填写报告',
  'scout.visitReport.compliance.lockoutDescription': '请先完成所有待填拜访报告再继续。',
  'scout.visitReport.compliance.deferButton': '稍后填写',
  'scout.visitReport.compliance.deferCount': '剩余 {{remaining}} 次推迟',
  'scout.visitReport.compliance.noDeferrals': '无可用推迟次数',
  'scout.visitReport.compliance.fillReport': '填写报告',
  'scout.visitReport.compliance.morningLockout': '在完成所有待填报告前，日计划将被锁定。',

  // Learning — Lehrplan & Curriculum (pages)
  'learning.lehrplan.title': '课程',
  'learning.lehrplan.subtitle': '管理课程与学习目标',
  'learning.curriculumPlanning.title': '课程规划',
  'learning.curriculumPlanning.subtitle': '规划课程结构并分配学习内容',

  // Navigation (App Overview, Tile View)
  'navigation.appOverview': '应用概览',

  // PO Sprints (page titles)

  // Purchase (list/detail)

  // Sales (list)

  // Common (extra)
  'common.next': '下一步',

  // Warehouse Picking (action)

  // Scout Wochenplanung — Aggregates

  // Scout Mission Control — Plan View

  // CRM — Leads page (flat keys used in table/modal)
  'crm.leads': '线索',
  'crm.closedWon': '已成交',
  'crm.searchPlaceholder': '搜索线索...',
  'crm.name': '姓名',
  'crm.company': '公司',
  'crm.contact': '联系人',
  'crm.source': '来源',
  'crm.value': '价值',
  'crm.lastContact': '最后联系',
  'crm.viewDetails': '查看详情',
  'crm.editLead': '编辑线索',
  'crm.addNote': '添加备注',
  'crm.convertToCustomer': '转为客户',
  'crm.deleteLead': '删除线索',
  'crm.leadDetails': '线索详情',
  'crm.addNewLead': '新建线索',
  'crm.viewLeadDetails': '查看线索详情',
  'crm.createNewLead': '新建线索',
  'crm.fullName': '全名',
  'crm.email': '邮箱',
  'crm.phone': '电话',
  'crm.estimatedValue': '预估价值',
  'crm.notes': '备注',
  'crm.status.new': '新线索',
  'crm.status.contacted': '已联系',
  'crm.status.qualified': '已确认',
  'crm.status.proposal': '报价',
  'crm.status.negotiation': '谈判中',
  'crm.status.closedWon': '已成交',
  'crm.status.closedLost': '已流失',
  'crm.source.website': '网站',
  'crm.source.referral': '推荐',
  'crm.source.tradeShow': '展会',
  'crm.source.coldCall': '陌拜',
  'crm.source.socialMedia': '社交媒体',
  'crm.source.emailCampaign': '邮件营销',

  // Supplier onboarding — Form (CompanyInfoSection, ContactInfoSection, DocumentUploadSection)

  // Placeholders (supplier forms)

  // Form (supplier — ContactInfoSection)

  // Role (supplier contact)

  // Country (supplier address)
  'country.US': '美国',
  'country.CA': '加拿大',
  'country.MX': '墨西哥',
  'country.GB': '英国',
  'country.DE': '德国',
  'country.FR': '法国',
  'country.other': '其他',

  // Business type (supplier — CompanyInfoSection uses businessType.*)

  // Missing keys (added from en/de)
  'common.saving': '保存中…',
  'common.archive': '归档',
  'scout.missions.industries.placeholder': '选择行业',
  'scout.missions.industries.search': '搜索行业…',
  'scout.missions.industries.empty': '未找到行业',
  'scout.missions.products.placeholder': '选择产品系列',
  'scout.missions.products.search': '搜索产品系列…',
  'scout.missions.products.empty': '未找到产品系列',
  'scout.search.selectStatus': '选择状态…',
  'scout.dailyPlanning.jokerAdd': '使用王牌',
  'scout.dailyPlanning.jokerTitle': '王牌停靠',
  'scout.dailyPlanning.jokerUsed': '已使用',
  'scout.dailyPlanning.jokerLimitReached': '已达每日王牌停靠上限。',
  'scout.dailyPlanning.jokerCompany': '公司',
  'scout.dailyPlanning.jokerCompanyPlaceholder': '输入公司名称',
  'scout.dailyPlanning.jokerReason': '原因',
  'scout.dailyPlanning.jokerReasonPlaceholder': '为何需要此次停靠？',
  'scout.dailyPlanning.jokerCancel': '取消',
  'scout.dailyPlanning.jokerSubmit': '使用王牌',
  'scout.dailyPlanning.jokerCreateError': '无法创建王牌停靠。',
  'missions.management.decisionMakerMet': '已见决策人',
  'missions.management.wonAmount': '成交金额',
  'common.active': '活跃',
  'common.archived': '已归档',
  'common.planned': '已计划',
  'missionControl.totalLeads': '总线索数',
  'missionControl.completedLeads': '已完成线索',

  'survey.contact.name': '姓名',
  'survey.contact.namePlaceholder': '输入姓名',
  'survey.contact.function': '职务 / 角色',
  'survey.contact.functionPlaceholder': '输入职务',
  'survey.contact.email': '电子邮件',
  'survey.contact.emailPlaceholder': '输入电子邮件地址',
  'survey.contact.phone': '电话',
  'survey.contact.phonePlaceholder': '输入电话号码',
  'survey.contact.isDecisionMaker': '是决策者？',
}
